import type { Housings } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const housingTableColumns: EquipmentTableColumn<Housings>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    field: "housing_number",
    header: "Housing #",
    editable: true,
    isNumber: true
  },
  {
    field: "stage_count",
    header: "Stage Count",
    editable: true,
    isNumber: true
  },
  {
    field: "length_inches",
    header: "Length (in)",
    editable: true,
    isNumber: true,
    decimalPlaces: 6
  },
  {
    field: "weight_pounds",
    header: "Weight (lb)",
    editable: true,
    isNumber: true,
    decimalPlaces: 6
  }
];
